export const preparationSubstageLabel = (substage) => ({
  cv_extraction: 'Reviewing CV facts',
  jd_cv_matching: 'Comparing CV evidence with role requirements',
  cached_jd_match: 'Using saved evidence matching',
  evidence_target_mapping: 'Organizing evidence targets',
}[substage] || '');

export function preparationStepState(steps, preparation, index) {
  const activeIndex = Math.max(0, steps.findIndex((step) => step.stage === preparation.stage));
  const history = (preparation.stageHistory || []).filter((item) => (
    !preparation.attempt || Number(item.attempt || 1) === Number(preparation.attempt)
  ));
  const completed = history.some((item) => item.stage === steps[index].stage && item.completed_at);
  return {
    active: index === activeIndex,
    done: index < activeIndex && (history.length ? completed : true),
  };
}
